export const trim = (str: string) => {
    if (!str) {
        return '';
    }
    return str.trim();
};

export function strLen(str: string) {
    if (!str) {
        return 0;
    }
    let len = 0;
    for (let i = 0; i < str.length; i++) {
        const c = str.charCodeAt(i);
        // 单字节加1
        if ((c >= 0x0001 && c <= 0x007e) || (c >= 0xff60 && c <= 0xff9f)) {
            len++;
        } else {
            len += 2;
        }
    }
    return len;
}

export function cutStr(str: string, maxNum: number) {
    if (!str) {
        return '';
    }
    let len = 0;
    for (let i = 0; i < str.length; i++) {
        const c = str.charCodeAt(i);
        // 单字节加1
        if ((c >= 0x0001 && c <= 0x007e) || (c >= 0xff60 && c <= 0xff9f)) {
            len++;
        } else {
            len += 2;
        }
        if (len === maxNum) {
            return str.slice(0, i + 1);
        }
        if (len > maxNum) {
            return str.slice(0, i);
        }
    }
    return str;
}
